import {
  useAcceptMessageMutation,
  useRejectMessageMutation,
} from "api/apiSlice";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { IMessage, messageDeExer } from "api/apiTypes";

interface PendingMessageProps {
  message: IMessage;
}

export const PendingMessage = (props: PendingMessageProps) => {
  const message = props.message;
  const [acceptMessage] = useAcceptMessageMutation();
  const [rejectMessage] = useRejectMessageMutation();

  const onAcceptClicked = async (messageId: string) => {
    acceptMessage(messageId);
  };

  const onRejectClicked = async (messageId: string) => {
    rejectMessage(messageId);
  };

  return (
    <tr>
      <td className="col-3">
        <div className="container">
          <div className="row">
            <div className="col-4">
              <Image roundedCircle src={message.authorUrl} />
            </div>
            <div className="col-8">
              <p className="h4">{message.author}</p><p className="text-secondary mb-0">{message.streamName} Stream</p>
              <p className="text-secondary">{message.datetime}</p>
            </div>
          </div>
        </div>
      </td>
      <td className="align-middle">
        <p>{messageDeExer(message.messageEx)}</p>
      </td>
      <td className="align-middle text-center col-2">
        <Button
          variant="success"
          className="me-2"
          onClick={() => onAcceptClicked(message.messageId)}
        >
          Accept
        </Button>
        <Button
          variant="danger"
          onClick={() => onRejectClicked(message.messageId)}
        >
          Reject
        </Button>
      </td>
    </tr>
  );
};
